module.exports = __webpack_public_path__ + "media/images/landing/persons/tess-kratochvilova-f696ed14da36a28b139cd95e3a138d96.jpg";